"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.messagePhraseByType = exports.default = exports.NotificationStatus = exports.NotificationReason = void 0;

var _preact = require("preact");

var _absoluteUrlRuntime = require("@insided/shared/utils/absoluteUrlRuntime");

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _classnames = _interopRequireDefault(require("classnames"));

var _axios = _interopRequireDefault(require("axios"));

var _Tooltip = _interopRequireDefault(require("@insided/shared/uikit/Tooltip"));

var _UserAvatar = _interopRequireDefault(require("@insided/deprecated-preact-components/User/UserAvatar"));

var _Button = _interopRequireDefault(require("@insided/shared/uikit/Button"));

var _phrase = _interopRequireDefault(require("@insided/deprecated-libs/translationsUtils/phrase"));

var _common = require("@insided/shared/utils/common");

var _debounce = require("@insided/shared/utils/debounce");

var _dateFormatting = require("@insided/shared/utils/dateFormatting");

var _messagePhraseByType;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var NotificationStatus;
exports.NotificationStatus = NotificationStatus;

(function (NotificationStatus) {
  NotificationStatus["New"] = "new";
  NotificationStatus["Seen"] = "seen";
  NotificationStatus["Read"] = "read";
})(NotificationStatus || (exports.NotificationStatus = NotificationStatus = {}));

var NotificationReason;
exports.NotificationReason = NotificationReason;

(function (NotificationReason) {
  NotificationReason["mentionInReply"] = "mention: new reply";
  NotificationReason["mentionInTopic"] = "mention: new topic";
  NotificationReason["mention"] = "mention";
  NotificationReason["newReply"] = "new reply";
  NotificationReason["newTopic"] = "new topic";
  NotificationReason["newProductUpdate"] = "new product update";
  NotificationReason["questionAnswered"] = "answer";
  NotificationReason["privateMessage"] = "private message sent";
  NotificationReason["groupInvite"] = "group invite";
  NotificationReason["groupMemberApproved"] = "group member approved";
})(NotificationReason || (exports.NotificationReason = NotificationReason = {}));

var messagePhraseByType = (_messagePhraseByType = {}, (0, _defineProperty2.default)(_messagePhraseByType, NotificationReason.mentionInReply, 'notification.center.messages.mention'), (0, _defineProperty2.default)(_messagePhraseByType, NotificationReason.mentionInTopic, 'notification.center.messages.mention'), (0, _defineProperty2.default)(_messagePhraseByType, NotificationReason.mention, 'notification.center.messages.mention'), (0, _defineProperty2.default)(_messagePhraseByType, NotificationReason.newReply, 'notification.center.messages.newReply'), (0, _defineProperty2.default)(_messagePhraseByType, NotificationReason.newTopic, 'notification.center.messages.newTopic'), (0, _defineProperty2.default)(_messagePhraseByType, NotificationReason.newProductUpdate, 'notification.center.messages.newProductUpdate'), (0, _defineProperty2.default)(_messagePhraseByType, NotificationReason.questionAnswered, 'notification.center.messages.topicAnswered'), (0, _defineProperty2.default)(_messagePhraseByType, NotificationReason.privateMessage, 'notification.center.messages.privateMessage'), (0, _defineProperty2.default)(_messagePhraseByType, NotificationReason.groupInvite, 'notification.center.messages.groupInvitation'), (0, _defineProperty2.default)(_messagePhraseByType, NotificationReason.groupMemberApproved, 'notification.center.messages.groupJoinApproval'), _messagePhraseByType);
exports.messagePhraseByType = messagePhraseByType;

var NotificationCenterItem = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(NotificationCenterItem, _Component);

  var _super = _createSuper(NotificationCenterItem);

  function NotificationCenterItem() {
    var _this;

    (0, _classCallCheck2.default)(this, NotificationCenterItem);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "state", {
      userAvatar: '',
      isStatusReadLoading: false
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "checkIsRead", function (status) {
      return status === NotificationStatus.Read;
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "debouncedChangeNotificationStatus", (0, _debounce.debounceAsync)( /*#__PURE__*/function () {
      var _ref = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(isRead) {
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this.changeNotificationStatus(isRead);

              case 2:
                return _context.abrupt("return", _context.sent);

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }(), 500));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onStatusClick", /*#__PURE__*/function () {
      var _ref2 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2(e) {
        var _this$props$onStatusC, _this$props, _this$props$id;

        return _regenerator.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                e.preventDefault();
                e.stopImmediatePropagation();
                (_this$props$onStatusC = (_this$props = _this.props).onStatusChange) === null || _this$props$onStatusC === void 0 ? void 0 : _this$props$onStatusC.call(_this$props, (_this$props$id = _this.props.id) !== null && _this$props$id !== void 0 ? _this$props$id : '');
                _context2.next = 5;
                return _this.debouncedChangeNotificationStatus(_this.checkIsRead(_this.props.status));

              case 5:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      return function (_x2) {
        return _ref2.apply(this, arguments);
      };
    }());
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "changeNotificationStatus", /*#__PURE__*/function () {
      var _ref3 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee3(isRead) {
        var url;
        return _regenerator.default.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                url = isRead ? '/notificationcenter/mark-unread/' : '/notificationcenter/mark-read/';
                _context3.next = 3;
                return _axios.default.post("".concat(url).concat(_this.props.id));

              case 3:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      return function (_x3) {
        return _ref3.apply(this, arguments);
      };
    }());
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onLinkClick", /*#__PURE__*/function () {
      var _ref4 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee4(e) {
        var _ref5, _reply$url;

        var _this$props2, id, status, reply, data, isStatusReadLoading, isRead, url;

        return _regenerator.default.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                e.preventDefault();
                _this$props2 = _this.props, id = _this$props2.id, status = _this$props2.status, reply = _this$props2.reply, data = _this$props2.data;
                isStatusReadLoading = _this.state.isStatusReadLoading;
                isRead = _this.checkIsRead(status);

                if (!(!isRead && !isStatusReadLoading)) {
                  _context4.next = 9;
                  break;
                }

                _this.setState({
                  isStatusReadLoading: true
                });

                _context4.next = 8;
                return _axios.default.post("/notificationcenter/mark-read/".concat(id));

              case 8:
                _this.setState({
                  isStatusReadLoading: false
                });

              case 9:
                url = (_ref5 = (_reply$url = reply.url) !== null && _reply$url !== void 0 ? _reply$url : data === null || data === void 0 ? void 0 : data.url) !== null && _ref5 !== void 0 ? _ref5 : '';
                window.location.assign(url);

              case 11:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }));

      return function (_x4) {
        return _ref4.apply(this, arguments);
      };
    }());
    return _this;
  }

  (0, _createClass2.default)(NotificationCenterItem, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      var img = new Image();
      img.src = this.props.author.avatar;

      img.onload = function () {
        var _this2$props$author$a;

        _this2.setState({
          userAvatar: (_this2$props$author$a = _this2.props.author.avatar) !== null && _this2$props$author$a !== void 0 ? _this2$props$author$a : ''
        });
      };
    }
  }, {
    key: "render",
    value: function render() {
      var _ref6, _reply$title, _data$groupThumbNail, _ref7, _reply$url2, _author$username, _data$categoryName;

      var _this$props3 = this.props,
          id = _this$props3.id,
          status = _this$props3.status,
          author = _this$props3.author,
          reply = _this$props3.reply,
          isNew = _this$props3.isNew,
          createdAt = _this$props3.createdAt,
          reason = _this$props3.reason,
          data = _this$props3.data,
          withButtons = _this$props3.withButtons,
          onAcceptClick = _this$props3.onAcceptClick,
          onDismissClick = _this$props3.onDismissClick;
      var isRead = this.checkIsRead(status); // Convert UTC time to local timezone

      var utcTime = new Date(createdAt);
      var localTime = (0, _dateFormatting.formatLocalDateToSQL)(utcTime);
      var relativeTime = createdAt ? _common.common.relativeDate(localTime) : '';
      var timeTrimmed = relativeTime.replace(/Forum|\|/gi, '').trim();
      var title = (_ref6 = (_reply$title = reply.title) !== null && _reply$title !== void 0 ? _reply$title : data === null || data === void 0 ? void 0 : data.title) !== null && _ref6 !== void 0 ? _ref6 : '';
      var isGroupThumbnailURLValid = !!((_data$groupThumbNail = data.groupThumbNail) !== null && _data$groupThumbNail !== void 0 && _data$groupThumbNail.length) && data.groupThumbNail.match(/\.(jpeg|jpg|gif|png)$/) != null;
      var userAvatarData = {
        id: author.id,
        name: author.username,
        avatar: this.state.userAvatar
      };
      var groupAvatarData = {
        id: 1,
        name: data.title,
        avatar: isGroupThumbnailURLValid ? data.groupThumbNail : ''
      };
      var avatarData = reason === NotificationReason.groupMemberApproved ? groupAvatarData : userAvatarData;
      return (0, _preact.h)("a", {
        href: (0, _absoluteUrlRuntime.resolveUrl)((_ref7 = (_reply$url2 = reply.url) !== null && _reply$url2 !== void 0 ? _reply$url2 : data === null || data === void 0 ? void 0 : data.url) !== null && _ref7 !== void 0 ? _ref7 : ''),
        onClick: this.onLinkClick,
        className: (0, _classnames.default)('notification-center__item', {
          'notification-center__item--new': isNew
        }),
        "data-track-type": "click",
        "data-element-name": "Notification Center Item",
        "data-notification-type": reason,
        "data-notification-id": id,
        "data-notification-unread": "".concat(!isRead)
      }, (0, _preact.h)("div", {
        className: "notification-center__item__avatar"
      }, (0, _preact.h)(_UserAvatar.default, {
        user: avatarData,
        openInNewTab: true,
        disablePopup: true,
        style: {
          width: '40px',
          height: '40px'
        }
      })), (0, _preact.h)("div", {
        className: "notification-center__item__content"
      }, (0, _preact.h)("div", {
        className: "notification-center__item__description"
      }, (0, _preact.h)(_phrase.default, {
        p: messagePhraseByType[reason],
        count: {
          username: (_author$username = author.username) !== null && _author$username !== void 0 ? _author$username : '',
          title: title,
          categoryName: (_data$categoryName = data === null || data === void 0 ? void 0 : data.categoryName) !== null && _data$categoryName !== void 0 ? _data$categoryName : ''
        }
      })), (0, _preact.h)("div", {
        className: "notification-center__item__time"
      }, timeTrimmed), withButtons ? (0, _preact.h)("div", {
        className: "notification-center__item__buttons"
      }, (0, _preact.h)(_Button.default, {
        variant: "primary",
        onClick: onAcceptClick
      }, "Accept"), (0, _preact.h)(_Button.default, {
        variant: "secondary",
        onClick: onDismissClick
      }, "Dismiss")) : null), (0, _preact.h)("div", {
        className: "notification-center__item__mark-wrapper"
      }, (0, _preact.h)(_Tooltip.default, {
        withArrow: true,
        position: "right",
        top: -4,
        left: -10,
        trigger: (0, _preact.h)("div", {
          className: "notification-center__item__mark",
          role: "button",
          onClick: this.onStatusClick
        }, (0, _preact.h)("div", {
          className: (0, _classnames.default)('notification-center__item__indicator', {
            'is-read': isRead
          })
        })),
        tooltipMessage: (0, _preact.h)("div", {
          className: "notification-center__item__mark__tooltip"
        }, isRead ? (0, _preact.h)(_phrase.default, {
          p: "notification.center.information.markAsUnread"
        }) : (0, _preact.h)(_phrase.default, {
          p: "notification.center.information.markAsRead"
        }))
      })));
    }
  }]);
  return NotificationCenterItem;
}(_preact.Component);

var _default = NotificationCenterItem;
exports.default = _default;